import React, { useState, useRef, useEffect } from 'react'
import './solution_screen.css'
import CreateSolutionWidget from './create_solution/create_solution';
import AppBarWidget from '../../widgets/app_bar/app_bar';
import PagesTitle from '../../widgets/pages_title/pages_title';
import { useSelector } from 'react-redux';
import { showAlert } from '../../functions/show_alert';
import { Navigate } from 'react-router-dom';
import SolutionImp from './solution_implimentation/solution_imp';

export default function SolutionScreen() {
    const [solutionImplementaion, SetSolutionImplimantation] = useState(false);
    const state = useSelector(state => state.projectSlice.projectSelected);
    const selectedEvent = state?.selectedEvent;
    const eventProblemMapRef = useRef(new Map());

    // Load event problem map from localStorage
    useEffect(() => {
        const getStorageKey = () => `eventProblems_${state?.id || 'default'}`;
        try {
            const stored = localStorage.getItem(getStorageKey());
            if (stored) {
                const parsed = JSON.parse(stored);
                const map = Array.isArray(parsed) ? new Map(parsed) : new Map(Object.entries(parsed));
                eventProblemMapRef.current = map;
            }
        } catch (error) {
            console.error('Error loading event problem map:', error);
        }
    }, [state?.id, selectedEvent?.id, state?.problem]);

    if (!selectedEvent) {
        showAlert(false, 'Select an event first');
        return <Navigate to={'/event'} />
    }

    // Check if a specific problem exists for this event (using localStorage mapping)
    // Only allow solution screen if a problem was created for this specific event
    const getProblemIdForEvent = () => {
        if (!selectedEvent?.id) return null;

        // Check if the mapping exists in the ref
        if (eventProblemMapRef.current.has(selectedEvent.id)) {
            return eventProblemMapRef.current.get(selectedEvent.id);
        }

        // If not in ref, try to reload from localStorage
        const getStorageKey = () => `eventProblems_${state?.id || 'default'}`;
        try {
            const stored = localStorage.getItem(getStorageKey());
            if (stored) {
                const parsed = JSON.parse(stored);
                const map = Array.isArray(parsed) ? new Map(parsed) : new Map(Object.entries(parsed));
                if (map.has(selectedEvent.id)) {
                    eventProblemMapRef.current = map;
                    return map.get(selectedEvent.id);
                }
            }
        } catch (error) {
            console.error('Error loading event problem map:', error);
        }

        return null;
    };

    const problemIdForEvent = getProblemIdForEvent();

    // Find the specific problem for this event
    const problemForEvent = problemIdForEvent && state.problem && Array.isArray(state.problem)
        ? state.problem.find(obj => String(obj.id) === String(problemIdForEvent))
        : null;

    // Only allow access if a specific problem exists for this event
    if (!problemForEvent) {
        showAlert(false, 'Create Problem first');
        return <Navigate to={'/problem'} />
    }
    if (solutionImplementaion) {
        return (
            <>
                <AppBarWidget />
                <div id='solution-screen-top'>
                    <PagesTitle title={'Solution'} />
                </div>
                <div id='solution-screen'>
                    <SolutionImp SetSolutionImplimantation={SetSolutionImplimantation} project={state} selectedEvent={selectedEvent} />
                </div>
            </>

        )
    } else {
        return (
            <>
                <AppBarWidget />
                <div id='solution-screen-top'>
                    <PagesTitle title={'Solution'} />
                </div>
                <div id='solution-screen'>
                    <CreateSolutionWidget SetSolutionImplimantation={SetSolutionImplimantation} project={state} selectedEvent={selectedEvent} />
                </div>
            </>

        )
    }

}

